import type {OrganizationUserData} from './types';

export function getUserName(user: OrganizationUserData): string {
    if (!user) {
        return '';
    }

    return (
        user.name ||
        `${user.givenName || ''} ${user.familyName || ''}`.trim() ||
        user.preferredUsername ||
        user.yandexClaims?.login ||
        user.sub ||
        ''
    );
}
